import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import sendRoleClearRequest from "./components/sendRoleClearRequest.vue";
import infoList from "../../mixins/infoList";
import roleClearTable from "./components/roleClearTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
import { getRoleClearList } from "@/api/roleClear";
import { roleClearStateList } from "@/define/roleClearDefine";
import { getUserInfoMap, getGameServerMap } from "@/utils/dictionary";
import { approveRoleClear } from "@/api/roleClear";
import serverList from "../../components/serverList/serverOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    sendRoleClearRequest: sendRoleClearRequest,
    DataOptions: DataOptions,
    roleClearTable: roleClearTable
  },
  data: function data() {
    return {
      listApi: getRoleClearList,
      requestDialog: false,
      approveDialog: false,
      approveData: {},
      state: 1,
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      options: roleClearStateList,
      roleList: [],
      radio: null,
      approveReason: '',
      userInfoMap: null,
      gameServerMap: null
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.onQueryBtn();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    newRequest: function newRequest() {
      this.requestDialog = true;
    },
    onClosePanel: function onClosePanel() {
      this.requestDialog = false;
      this.onQueryBtn();
    },
    onEdit: function onEdit(data) {
      var _this2 = this;
      this.requestDialog = true;
      setTimeout(function () {
        _this2.$refs.dialog.initData(data);
      }, 10);
    },
    onApprove: function onApprove(data) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _iterator, _step, roleId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.approveData = data;
              if (!(_this3.userInfoMap == null)) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return getUserInfoMap();
            case 4:
              _this3.userInfoMap = _context2.sent;
            case 5:
              if (!(_this3.gameServerMap == null)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 8;
              return getGameServerMap();
            case 8:
              _this3.gameServerMap = _context2.sent;
            case 9:
              _this3.roleList.length = 0;
              _iterator = _createForOfIteratorHelper(data.role_list.split(','));
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  roleId = _step.value;
                  _this3.roleList.push({
                    id: roleId,
                    name: _this3.tableData.role_name[roleId] || '???'
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this3.approveReason = '';
              _this3.radio = null;
              _this3.approveDialog = true;
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onApproveConfirm: function onApproveConfirm() {
      var _this4 = this;
      if (!this.radio) {
        this.$message.error('请选择审批结果');
        return;
      }
      approveRoleClear({
        id: this.approveData.id,
        is_approve: this.radio === '1',
        approve_reason: this.approveReason
      }).then(function (result) {
        if (result.code == 0) {
          _this4.approveDialog = false;
          _this4.onQueryBtn();
        }
      });
    },
    onApproveCancel: function onApproveCancel() {
      this.approveDialog = false;
    },
    onQueryBtn: function onQueryBtn() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.searchInfo.sdate = _this5.formTime[0];
              _this5.searchInfo.edate = _this5.formTime[1];
              _this5.searchInfo.state = _this5.state;
              _context3.next = 5;
              return _this5.getTableData();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};